import Vue from '../vue/common/vue-common';
import BrandBook from '../vue/components/brand-book-6/BrandBook';

requestIdleCallback(() => new Vue(BrandBook));
